<template>
  <div class="d-flex flex-column gap-2">
    <v-card v-for="(rule, index) in rules" :key="index" outlined class="pa-3">
      <div class="d-flex align-center mb-2 gap-1">
        <v-icon small>{{ getRuleByItemKey(rule.itemKey).Group.icon }}</v-icon>
        <v-icon small>{{ getRuleByItemKey(rule.itemKey).icon }}</v-icon>
        <p class="mb-0 ml-1 font-weight-bold">
          {{ getRuleByItemKey(rule.itemKey).label }}
        </p>
        <v-spacer />
        <v-btn icon @click="removePrecificationRule(index)" small color="error">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </div>
      <v-select
        v-model="rule.pricingType"
        :items="
          getRuleByItemKey(rule.itemKey).allowedTypes.map((type) => ({
            value: type,
            text: pricingTypes[type],
          }))
        "
        label="Tipo de precificação"
        outlined
        dense
        class="mb-2"
        hide-details
      >
      </v-select>

      <component :is="rule.pricingType" v-model="rule.config" />
    </v-card>

    <v-menu>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          color="primary"
          block
          depressed
          text
          small
        >
          Adicionar Regra
        </v-btn>
      </template>
      <v-list dense>
        <template v-for="(group, index) in availableRulesGroups">
          <v-divider
            v-if="index > 0"
            :key="group.label + 'divider'"
            class="my-2"
          />

          <h6
            :key="group.label + 'header'"
            class="mx-2 mb-0 text-subtitle-1 font-weight-bold"
          >
            <v-icon small left>{{ group.icon }}</v-icon>
            {{ group.label }}
          </h6>
          <v-list-item
            v-for="item in group.items"
            :key="item.id"
            @click="addPrecificationRule(item.id)"
          >
            <v-icon small left>{{ item.icon }}</v-icon>
            {{ item.label }}
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import FIXED from "./pricingTypes/Fixed.vue";
import PERCENTAGE from "./pricingTypes/Percentage.vue";
// import TIERS from "./pricingTypes/Tiers.vue";
import PER_UNIT from "./pricingTypes/PerUnit.vue";
import INVOICE_DEFINITIONS from "@/definitions/InvoiceDefinitions";

const pricingTypes = {
  FIXED: "Fixo em caso de uso",
  PERCENTAGE: "Percentual",
  TIERS: "Tiers",
  PER_UNIT: "Por unidade",
};
const RuleItems = Object.entries(INVOICE_DEFINITIONS.itemKey)
  .map(([key, value]) => ({
    key,
    id: key,
    ...value,
  }))
  .filter((item) => !!item.allowedTypes);

export default {
  name: "PrecificationRulesController",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    FIXED,
    PERCENTAGE,
    PER_UNIT,
  },
  data: () => ({
    RuleItems,
    pricingTypes,
  }),
  methods: {
    getRuleByItemKey(itemKey) {
      const item = this.RuleItems.find((item) => item.id === itemKey);
      return {
        ...item,
        Group: INVOICE_DEFINITIONS.itemGroups[item.group],
      };
    },
    removePrecificationRule(index) {
      this.rules = this.rules.filter((_, i) => i !== index);
    },
    addPrecificationRule(itemKey) {
      const pricingType = RuleItems.find((item) => item.id === itemKey)
        ?.allowedTypes[0];
      const newRule = {
        itemKey,
        pricingType,
        config: {},
      };
      this.rules = [...this.rules, newRule];
    },
  },

  computed: {
    availableRulesGroups() {
      return Object.entries(INVOICE_DEFINITIONS.itemGroups)
        .map(([groupKey, group]) => ({
          id: groupKey,
          ...group,
          items: this.RuleItems.filter(
            (item) =>
              item.group === groupKey &&
              !this.rules.some((rule) => rule.itemKey === item.id)
          ),
        }))
        .filter((group) => group.items.length > 0);
    },
    rules: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
